/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, size: NonNullable<unknown> }} Placeflyersprintlabel3Inputs */

const en_placeflyersprintlabel3 = /** @type {(inputs: Placeflyersprintlabel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Print ${i?.name} in ${i?.size}`)
};

const de_placeflyersprintlabel3 = /** @type {(inputs: Placeflyersprintlabel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} in ${i?.size} drucken`)
};

/**
* | output |
* | --- |
* | "Print {name} in {size}" |
*
* @param {Placeflyersprintlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyersprintlabel3 = /** @type {((inputs: Placeflyersprintlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyersprintlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyersprintlabel3(inputs)
	return de_placeflyersprintlabel3(inputs)
});
export { placeflyersprintlabel3 as "placeFlyersPrintLabel" }